/**
 * PageHero's light + grid backdrop, sized for the catalog's wider,
 * left-aligned headers. Place inside a `relative` parent.
 */
export function CatalogBackdrop() {
  return (
    <div aria-hidden className="pointer-events-none absolute -inset-x-6 -top-28 bottom-0 overflow-hidden">
      <div className="absolute -top-[30rem] left-[30%] h-[46rem] w-[72rem] -translate-x-1/2 rounded-full bg-[radial-gradient(closest-side,color-mix(in_srgb,var(--color-primary)_16%,transparent),transparent)]" />
      <div className="absolute inset-0 [background-image:linear-gradient(var(--color-border)_1px,transparent_1px),linear-gradient(90deg,var(--color-border)_1px,transparent_1px)] [background-size:72px_72px] [mask-image:radial-gradient(ellipse_60%_80%_at_25%_0%,black,transparent)]" />
    </div>
  )
}
